import { Chip, Typography } from '@mui/material'
import { useMemo } from 'react'

import { useTranslation } from '@/core'
import { Organism, OrganismFrame } from '@/core/architecture'

type ResaleTagProps = {
  status: string
}

export enum ResaleItemStatus {
  Open = '10_open',
  Matched = '20_matched',
  NoMatched = '30_no_match',
  Sold = '40_sold',
  Paid = '50_paid',
  Canceled = '60_canceled',
}

export enum ResaleRaffleStatus {
  Win = '10_win',
  Applied = '20_applied',
  Invalid = '30_invalid',
  Canceled = '40_canceled',
  Lost = '50_lost',
  Purchased = '60_purchased',
}

export const ResaleTag: Organism<ResaleTagProps> = ({ status }) => {
  const { t } = useTranslation('resaleManagement')
  const { bgcolor, color } = useMemo(() => {
    switch (status) {
      case ResaleItemStatus.Open:
      case ResaleRaffleStatus.Applied:
      default:
        return { bgcolor: 'primary.main', color: 'white' }
      case ResaleItemStatus.Paid:
      case ResaleItemStatus.Sold:
        return { bgcolor: 'secondary.main', color: 'white' }
      case ResaleRaffleStatus.Win:
        return { bgcolor: 'error.main', color: 'white' }
      case ResaleItemStatus.Matched:
        return { bgcolor: 'primary.dark', color: 'white' }
      case ResaleRaffleStatus.Invalid:
      case ResaleRaffleStatus.Lost:
      case ResaleItemStatus.NoMatched:
      case ResaleItemStatus.Canceled:
        return { bgcolor: 'grey.100', color: 'text.secondary' }
      case ResaleRaffleStatus.Purchased:
        return { bgcolor: 'primary.dark', color: 'white' }
    }
  }, [status])

  if (status === ResaleRaffleStatus.Purchased) {
    return null
  }

  return (
    <OrganismFrame>
      <Chip
        size="small"
        sx={{
          height: 20,
          borderRadius: '10px',
          bgcolor,
          py: 1,
          px: 4,
          '.MuiChip-label': {
            px: 0,
          },
        }}
        label={
          <Typography color={color} variant="subtitle2">
            {t(status)}
          </Typography>
        }
      />
    </OrganismFrame>
  )
}
